export const getParams = (...params: string[]): Record<string, string> => {
  const urlParams = new URLSearchParams(location?.search);
  const result: Record<string, string> = {};

  params.forEach((param) => {
    const searchParam = urlParams.get(param);
    result[param] = searchParam || "";
  });

  return result;
};
